import React from "react";
import { Box, Checkbox, FormControlLabel } from "@material-ui/core";
import ParticipantsListTable from "../../table/participantsListTable";
import ParticipantSearchPanel from "../../search/participantSearch";
import { getLang } from "app/feature/constants";
import moment from "moment";

export default function ParticipantsListPanelComponent({
  data,
  isFetching,
  tableFilter,
  totalRecords,
  handleChangePage,
  handleChangeRowsPerPage,
  handleSearch,
  handleFetchLuckyDrawList,
  paginationOptions,
  language,
  lang,
  isError,
  luckyDrawUUID,
  luckyDraw,
  showWinnerOnly,
  setShowWinnerOnly,
}) {
  let isEnded = luckyDraw?.end_at
    ? moment().isAfter(moment.utc(luckyDraw?.end_at).local())
    : false;

  return (
    <Box>
      <ParticipantSearchPanel
        handleFilter={(value) => {
          handleSearch(value);
        }}
        luckyDraw={luckyDraw}
      />
      {(isEnded ||
        !!luckyDraw?.draw_end_at ||
        Number(luckyDraw?.type) === 2) && (
        <Box display="flex" justifyContent="flex-end" mb={1}>
          <FormControlLabel
            control={
              <Checkbox
                checked={showWinnerOnly}
                onChange={(e) => {
                  setShowWinnerOnly(e.target.checked);
                }}
              />
            }
            label={getLang(lang, "label.SHOW_WINNER_ONLY")}
          />
        </Box>
      )}

      <ParticipantsListTable
        data={data}
        isFetching={isFetching}
        page={tableFilter.page}
        search={tableFilter.search}
        rowsPerPage={tableFilter.rowsPerPage}
        totalRecords={totalRecords}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleFetchLuckyDrawList={handleFetchLuckyDrawList}
        paginationOptions={paginationOptions}
        lang={lang}
        language={language}
        isError={isError}
        luckyDrawUUID={luckyDrawUUID}
      />
    </Box>
  );
}
